/**
 * Mientras llega una página: una barra que se mueve y lo que está pasando.
 *
 * Sin `avance` —el servidor todavía está preparando la página, que la primera
 * vez hay que rasterizar y marcar— la barra va y viene; con él, se llena con lo
 * que lleva bajado. Antes en ese rato sólo había una pantalla en blanco, que se
 * confunde con un visor roto.
 */
export function BarraDeCarga({
  avance,
  texto,
  flotante = false,
}: {
  /** De 0 a 1, o `null` si todavía no se sabe cuánto falta. */
  avance: number | null;
  texto: string;
  /** Encima de la página anterior en vez de ocupar su lugar. */
  flotante?: boolean;
}) {
  const porcentaje = avance === null ? undefined : Math.round(avance * 100);
  return (
    <div className={`carga-pagina${flotante ? ' carga-pagina--flotante' : ''}`} role="status">
      <div
        className={`carga-pagina__barra${avance === null ? ' carga-pagina__barra--indeterminada' : ''}`}
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={porcentaje}
        aria-label={texto}
      >
        <span style={porcentaje === undefined ? undefined : { width: `${porcentaje}%` }} />
      </div>
      <span className="carga-pagina__texto">
        {texto}
        {porcentaje !== undefined && <span className="mono"> {porcentaje} %</span>}
      </span>
    </div>
  );
}
